module.exports = __webpack_public_path__ + "static/img/48.29ecf44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/48.png
// module id = YoLc
// module chunks = 1